import AxiosConfiguration from '@/classes/AxiosConfiguration';
const UserNotificationApiUrl = 'usernotification';

export const UserNotificationService = {
  async getNotificationsAsync(): Promise<any> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${UserNotificationApiUrl}`);
    return response.data;
  },
  async setNotificationsSeenAsync(): Promise<any> {
    const response = await AxiosConfiguration.axiosWithErrorPage.post(`${UserNotificationApiUrl}/seen`);
    return response.data;
  }
};
